import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getListOptions({ commit }, payload) {
    const res = await apiService.get(route('member.c-division.get-list-options'), payload)
    if (res.success && res.data) {
      return res.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
